const AuthDataState = {
  user: null,
  accessToken: null,
}

export default AuthDataState
